import { Link } from "react-router-dom";
import RichText from "@/components/RichText";
import { openCookiePreferences, useCookieBannerEnabled } from "@/lib/consent";

// Politique de confidentialité (/confidentialite) du moteur "default" —
// reprend à l'identique la mise en page de l'ancienne page codée en dur
// (pages/PrivacyPolicy.jsx, supprimée) : colonne unique de 760px, sur-titre
// doré, H1 serif, une section par bloc "privacy_block". Le contenu vient
// désormais du Studio (page « Politique de confidentialité »), voir
// backend/services/theme_engines/shared_pages.py.
//
// Valeurs par défaut identiques à PRIVACY_CONTENT_DEFAULT_PROPS côté
// serveur — voir HeroSection.jsx pour l'explication du repli.
const DEFAULTS = {
  privacy_eyebrow: "RGPD",
  privacy_heading: "Politique de confidentialité",
  privacy_intro: "",
  privacy_cookie_button_label: "Gérer mes préférences de cookies",
  privacy_back_label: "Retour à l'accueil",
  privacy_back_url: "/",
};

const isInternal = (url = "") => url.startsWith("/") && !url.startsWith("//");

export default function PrivacyContentSection({ props = {}, blocks = [] }) {
  const t = { ...DEFAULTS, ...props };
  const items = (blocks || []).filter((b) => b.type === "privacy_block" && b.enabled !== false);
  const bannerEnabled = useCookieBannerEnabled();
  const backClass =
    "inline-flex text-xs uppercase tracking-[0.1em] border border-ink/20 text-ink hover:border-ink transition-colors rounded-full px-5 py-2.5";

  return (
    <section className="max-w-[760px] mx-auto px-6 md:px-10 py-14 md:py-20">
      <RichText as="p" className="block text-xs uppercase tracking-[0.25em] text-gold font-medium mb-4" html={t.privacy_eyebrow} />
      <RichText as="h1" className="block font-serif text-3xl md:text-4xl font-medium text-ink mb-8" html={t.privacy_heading} />
      {t.privacy_intro && (
        <RichText
          as="div"
          preserveParagraphs
          className="text-ink/80 leading-relaxed text-sm md:text-base mb-10 [&_p]:mb-3 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-copper"
          html={t.privacy_intro}
        />
      )}

      <div className="space-y-10 text-ink/80 leading-relaxed">
        {items.map((b) => (
          <div key={b.id} data-block-key={b.id}>
            <RichText as="h2" className="block font-serif text-xl text-ink mb-3" html={b.props?.title} />
            <RichText
              as="div"
              preserveParagraphs
              className="text-sm md:text-base [&_p]:mb-2.5 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-copper"
              html={b.props?.body}
            />
          </div>
        ))}

        {bannerEnabled && t.privacy_cookie_button_label && (
          <div>
            <button type="button" onClick={openCookiePreferences} className={backClass} data-testid="privacy-cookie-prefs">
              {t.privacy_cookie_button_label}
            </button>
          </div>
        )}
      </div>

      {t.privacy_back_label && (
        <div className="mt-12">
          {isInternal(t.privacy_back_url || "/") ? (
            <Link to={t.privacy_back_url || "/"} className={backClass}>{t.privacy_back_label}</Link>
          ) : (
            <a href={t.privacy_back_url} className={backClass}>{t.privacy_back_label}</a>
          )}
        </div>
      )}
    </section>
  );
}
